// extracted by mini-css-extract-plugin
export default {"sectionTitle":"price_sectionTitle__gR4mO","priceRangeWrapper":"price_priceRangeWrapper__w-ITh","priceRange":"price_priceRange__ZtfID","priceDisplay":"price_priceDisplay__UY2Ve"};